<div class="page-menu">
    <div class="container">
        <pdf-viewer [src]="pdfSrc" [original-size]="false" ></pdf-viewer>
    </div>
</div>